import { SHOW_PLACEHOLDERS } from '../../../helpers/placeholders';

export const STATIC_TASKS = [
  {
    id: 'f1',
    category: 'follow_up',
    title: 'Follow up with Priya Desai',
    subtitle: 'No response after demo invite · 4 days ago',
    contact: 'Priya Desai',
    company: 'Lattice Health',
    campaign: 'Healthtech Ops',
    due: 'Today',
    priority: 'high',
  },
  {
    id: 'f2',
    category: 'follow_up',
    title: 'Send pricing recap to Tom Becker',
    subtitle: 'Promised on call · pending since Mon',
    contact: 'Tom Becker',
    company: 'Becker & Co',
    campaign: 'Inbound MQLs',
    due: 'Today',
    priority: 'high',
  },
  {
    id: 'f3',
    category: 'follow_up',
    title: 'Nudge cold thread — Lena Park',
    subtitle: 'Opened 3x, never replied',
    contact: 'Lena Park',
    company: 'Parallax',
    campaign: 'Design leaders',
    due: 'This week',
    priority: 'low',
  },
  {
    id: 'c1',
    category: 'call',
    title: 'Discovery call — Northbeam',
    subtitle: '30 min · Thursday 2:00 PM CET',
    contact: 'Sarah Lin',
    company: 'Northbeam',
    campaign: 'Q3 — SaaS Founders',
    due: 'Thu, 2:00 PM',
    priority: 'high',
  },
  {
    id: 'c2',
    category: 'call',
    title: 'Intro call — Lattice Health',
    subtitle: '15 min qualification call',
    contact: 'Priya Desai',
    company: 'Lattice Health',
    campaign: 'Healthtech Ops',
    due: 'Fri, 10:30 AM',
    priority: 'medium',
  },
  {
    id: 'o1',
    category: 'other',
    title: 'Warm up new mailbox: steven@pecunai.io',
    subtitle: 'Day 6 of 14 · open rate 92%',
    contact: '—',
    company: 'Pecunai',
    campaign: 'Account health',
    due: 'Ongoing',
    priority: 'low',
  },
  {
    id: 'o2',
    category: 'other',
    title: 'Re-verify 320 contacts in Healthtech list',
    subtitle: 'Bounce rate above 4% threshold',
    contact: '320 contacts',
    company: '—',
    campaign: 'Healthtech Ops',
    due: 'This week',
    priority: 'medium',
  },
  {
    id: 'o3',
    category: 'other',
    title: 'Review weekly performance report',
    subtitle: 'AI workforce summary · week 26',
    contact: '—',
    company: '—',
    campaign: '—',
    due: 'Friday',
    priority: 'low',
  },
];

/**
 * Only AI Approval is wired to anything. The other three list hard-coded sample
 * tasks, so selecting one showed invented work as though it were the user’s own —
 * marked rather than removed, because the categories are real and the lists
 * behind them are what is missing.
 */
export const TASK_CATEGORIES = [
  { id: 'ai_approval', label: 'AI Approval' },
  { id: 'follow_up', label: 'Follow up', comingSoon: true },
  { id: 'call', label: 'Call', comingSoon: true },
  { id: 'other', label: 'Other', comingSoon: true },
].filter(category => SHOW_PLACEHOLDERS || !category.comingSoon);
